import { GIG_GRID_LRG, GIG_GRID_MED, GIG_GRID_SML, GIG_GRID_XLRG } from '../../shared/Grid';

export const RECENTLY_VIEWED_SOURCE = 'your_recently_viewed_gigs';

export const sliderBaseNum = 8;

export const sliderBreakpoints = [
    {
        breakpoint: GIG_GRID_XLRG,
        slidesToScroll: 6,
        slides: 6
    },
    {
        breakpoint: GIG_GRID_LRG,
        slidesToScroll: 5,
        slides: 5
    },
    {
        breakpoint: GIG_GRID_MED,
        slidesToScroll: 4,
        slides: 4
    },
    {
        breakpoint: GIG_GRID_SML,
        slidesToScroll: 2,
        slides: 2
    }
];
